/* eslint-disable */
import React from 'react';

// ============================================================
// The Carolina Lemke Berlin wordmark as a vector — the prototype's #clbMark.
// <BrandMarkDefs/> is rendered ONCE by ShellRoot; <BrandMark/> instances
// reference it with <use>, so the app bar and the condensed mini-brand
// share the same paths and scale crisply at every size.
// ============================================================

const PATHS_MAIN = [
  [0, 'M1034 41V242L840 99C803 72 744 51 676 51C416 51 334 216 334 354C334 492 406 657 676 657C744 657 805 635 840 609L1034 466V666C958 685 860 718 676 718C316 718 68 564 68 354C68 149 310 -10 676 -10C874 -10 964 20 1034 41Z'],
  [1144, 'M1171 0 1040 122 641 708H519L111 122L-21 0H327L216 110L270 190H746L798 110L687 0ZM698 261H318L512 541Z'],
  [2374, 'M1220 0 1053 101 784 346C940 371 1048 443 1048 517C1048 649 844 708 580 708H51L172 587V121L51 0H509L388 121V325H546L879 0ZM802 514C802 435 696 389 560 389H388V644H580C726 644 802 595 802 514Z'],
  [3604, 'M1284 354C1284 549 1050 723 676 723C302 723 68 549 68 354C68 159 302 -15 676 -15C1050 -15 1284 159 1284 354ZM1018 354C1018 214 946 45 676 45C406 45 334 214 334 354C334 494 406 663 676 663C946 663 1018 494 1018 354Z'],
  [5016, 'M888 0V226L726 64H388V587L509 708H51L172 587V121L51 0Z'],
  [5976, 'M529 0 408 121V587L529 708H71L192 587V121L71 0Z'],
  [6636, 'M273 531 1080 -53V587L1201 708H858L979 587V259L368 708H51L172 587V121L51 0H394L273 121Z'],
  [7938, 'M1171 0 1040 122 641 708H519L111 122L-21 0H327L216 110L270 190H746L798 110L687 0ZM698 261H318L512 541Z'],
  [9674, 'M888 0V226L726 64H388V587L509 708H51L172 587V121L51 0Z'],
  [10634, 'M938 0V226L776 64H388V347H626L748 225V533L626 411H388V644H776L938 482V708H51L172 587V121L51 0Z'],
  [11682, 'M278 531 676 176 1146 595V121L1025 0H1483L1362 121V587L1483 708H1155L763 360L374 708H51L172 587V121L51 0H399L278 121Z'],
  [13296, 'M1242 0 590 408 1190 708H750L838 609L388 384V587L509 708H51L172 587V121L51 0H509L388 121V339L792 78V0Z'],
  [14556, 'M938 0V226L776 64H388V347H626L748 225V533L626 411H388V644H776L938 482V708H51L172 587V121L51 0Z'],
];
const PATHS_BERLIN = [
  [0, 'M1078 189C1078 272 928 343 760 366C898 390 1008 457 1008 534C1008 640 836 708 560 708H51L172 587V121L51 0H610C844 0 1078 45 1078 189ZM782 514C782 429 678 386 540 386H388V644H560C700 644 782 603 782 514ZM852 188C852 102 752 64 610 64H388V322H590C738 322 852 274 852 188Z'],
  [1452, 'M938 0V226L776 64H388V347H626L748 225V533L626 411H388V644H776L938 482V708H51L172 587V121L51 0Z'],
  [2760, 'M1220 0 1053 101 784 346C940 371 1048 443 1048 517C1048 649 844 708 580 708H51L172 587V121L51 0H509L388 121V325H546L879 0ZM802 514C802 435 696 389 560 389H388V644H580C726 644 802 595 802 514Z'],
  [4250, 'M888 0V226L726 64H388V587L509 708H51L172 587V121L51 0Z'],
  [5470, 'M529 0 408 121V587L529 708H71L192 587V121L71 0Z'],
  [6390, 'M273 531 1080 -53V587L1201 708H858L979 587V259L368 708H51L172 587V121L51 0H394L273 121Z'],
];

export function BrandMarkDefs() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true" focusable="false">
      <defs>
        <symbol id="clbMarkV3" viewBox="0 0 15544 1495">
          <g transform="translate(0,708) scale(1,-1)">
            {PATHS_MAIN.map(([x, d]) => <path key={x} transform={`translate(${x},0)`} d={d} />)}
          </g>
          <g transform="translate(5751.8,1494.8) scale(0.5294,-0.5294)">
            {PATHS_BERLIN.map(([x, d]) => <path key={x} transform={`translate(${x},0)`} d={d} />)}
          </g>
        </symbol>
      </defs>
    </svg>
  );
}

export function BrandMark({ className }) {
  return (
    <svg className={className} viewBox="0 0 15544 1495" fill="currentColor" aria-label="Carolina Lemke Berlin" role="img">
      <use href="#clbMarkV3" />
    </svg>
  );
}
